import React from 'react';
import styles from './HQDialog.module.css';

export default class HQDialog extends React.Component {
	render() {
		const {
			title = '',
			message = '',
			primaryButtonText = 'Confirm',
			onPrimaryClick,
			onCancelClick,
			isPrimaryDisabled = false,
		} = this.props;

		return (
			<div className={styles.dialogOverlay} role="presentation">
				<div
					className={styles.dialogCard}
					role="dialog"
					aria-modal="true"
					aria-labelledby="hq-dialog-title"
					aria-describedby="hq-dialog-message"
				>
					<h2 id="hq-dialog-title" className={styles.dialogTitle}>{title}</h2>
					<p id="hq-dialog-message" className={styles.dialogMessage}>{message}</p>

					<div className={styles.buttonRow}>
						<button
							type="button"
							className={styles.cancelButton}
							onClick={onCancelClick}
						>
							Cancel
						</button>

						<button
							type="button"
							className={styles.primaryButton}
							onClick={onPrimaryClick}
							disabled={isPrimaryDisabled}
						>
							{primaryButtonText}
						</button>
					</div>
				</div>
			</div>
		);
	}
}
